// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cU-z","smallCardRow":"dU-z","largeCardRow":"eU-z","productSearchRow":"fU-z","curatedRow":"gU-z"};